import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { AppConfig } from '../../../app.settings';
import { PlaylistsByUser } from '../../models/playlistByUser';

@Injectable()
export class AdministratorPlaylistService {

  endpoint: string;

  constructor(public http: HttpClient, public config: AppConfig) {
    this.endpoint = this.config.getConfig('api') + 'Admin/PlaylistManagement';
  }

  public getAllPlaylistByUsers(): Observable<PlaylistsByUser[]> {
    const urlFull = this.endpoint + '/UserPlaylistsByCompany';
    return this.http.get<PlaylistsByUser[]>(urlFull, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }

  public getAllPlaylists(): Observable<PlaylistsByUser[]> {
    const urlFull = this.endpoint + '/UserPlaylists';
    return this.http.get<PlaylistsByUser[]>(urlFull, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }

  public getAllPlaylistsByUser(userId: string): Observable<PlaylistsByUser> {
    const params = new HttpParams().set('userId', userId);

    const urlFull = this.endpoint + '/OwnedPlaylistsByUserId';
    return this.http.get<PlaylistsByUser>(urlFull, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), params });
  }

  public addPlaylistUserRelation(idUser, idPlaylist) {
    const data = {
      userId: idUser,
      playlistId: idPlaylist
    };
    const urlFull = this.endpoint + '/SharePlaylistWithUser';
    return this.http.post(urlFull, data, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }

  public removePlaylistUserRelation(idUser, idPlaylist) {
    const data = {
      userId: idUser,
      playlistId: idPlaylist
    };
    const urlFull = this.endpoint + '/DiscardPlaylistFromUser';
    return this.http.post(urlFull, data, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }


}
